import App from "./App";

window.addEventListener('load', function load() {
  const AppInstance = new App();
  AppInstance.bootstrap();
  window.removeEventListener('load', load, false);
}, false);


// WEBPACK FOOTER //
// ./ts/main.ts